module.exports = {

  isLiteral: true,

  bind: function () {
    this.vm.$$[this.expression] = this.el
  },

  unbind: function () {
    delete this.vm.$$[this.expression]
  }
  
}


/*****************
 ** WEBPACK FOOTER
 ** ../vue/src/directives/el.js
 ** module id = 42
 ** module chunks = 0
 **/